// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"443fc2b3","330":"4790df22","540":"2ced338c","586":"64694074","953":"dbf4261b"}[chunkId] + ".chunk.js";
};